import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WebhooksRoutingModule } from 'root/webhooks/webhooks-routing.module';
import { SharedModule } from 'shared/shared.module';
import { CreateWebhookComponent } from './create-webhook/create-webhook.component';
import { TestWebhookComponent } from './test-webhook/test-webhook.component';
import { UpdateWebhookComponent } from './update-webhook/update-webhook.component';
import { WebhooksComponent } from './webhooks/webhooks.component';

@NgModule({
  declarations: [
    WebhooksComponent,
    UpdateWebhookComponent,
    TestWebhookComponent,
    CreateWebhookComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    WebhooksRoutingModule,
  ],
})
export class WebhooksModule {
}
